function getTransModel(payCode){
    if(payCode == "PUN_ALIPAY") return "01";
    if(payCode == "PUN_WEIXIN") return "02";
    if(payCode == "PUN_UPAY") return "03";
    else return "99";
}
function payWay(value) {
    if (value == null || value == "") return "";
    else if (value == "PUN_ALIPAY") return "支付宝";
    else if (value == "PUN_WEIXIN") return "微信";
    else if (value == "PUN_CARD") return "银行卡";
    else if (value == "PUN_UPAY") return "银联云闪付";
    else
        return "其它";
}
function getPayWay(data){
    console.log(JSON.stringify(data));
    if(data.transMode == "01") return "PUN_ALIPAY";
    else if(data.transMode == "02") return "PUN_WEIXIN";
    else if(data.transMode == "03") return "PUN_UPAY";
    else return "PUN_CARD";
}
export { 
    getTransModel,payWay,getPayWay
}


// WEBPACK FOOTER //
// ./src/assets/js/anypay.js